import "../scss/style.scss";

// 1. Tell Core about our component immediately as the script parses
window.ThemeComponentOverrides = {
  ...(window.ThemeComponentOverrides || {}),
  VehicleFilterForm: {
    import: () => import("./partials/PageContent/VehicleFilterForm"),
  },
};

const bootTheme = () => {
  console.log("[Client Theme] Initialized.");

  // Safely trigger hydration to catch the newly registered VehicleFilterForm
  // The core hydrator's [data-hydrated='true'] safeguard prevents double-rendering.
  if (window.EcommerceCore?.app?.hydrateComponents) {
    window.EcommerceCore.app.hydrateComponents();
  }
};

// Start custom JS logic
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootTheme);
} else {
  // Use setTimeout here as well for consistency with core execution yielding
  setTimeout(bootTheme, 0);
}
